import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledLinkComponent } from "./link-component.scss";
import { withGenericConfig } from "contexts/generic-config-context";
import PictureComponent from "/components/core/picture/picture-component";
class LinkComponent extends PureComponent {
    render() {
        const { title, url, translate, onClickFunc, icon, headerCatalogLinks } = this.props;
        var _headerCatalogLinks_url;
        const resolvedUrl = (_headerCatalogLinks_url = headerCatalogLinks === null || headerCatalogLinks === void 0 ? void 0 : headerCatalogLinks[url]) !== null && _headerCatalogLinks_url !== void 0 ? _headerCatalogLinks_url : url;
        return /*#__PURE__*/ _jsxs(StyledLinkComponent, {
            className: "link-mobile-component",
            href: resolvedUrl,
            onClick: onClickFunc,
            children: [
                translate(title),
                icon && /*#__PURE__*/ _jsx(PictureComponent, {
                    className: "mobile-link-icon",
                    src: icon,
                    alt: translate(title)
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export default withGenericConfig(LinkComponent);
